import React from 'react';
import { Link } from 'react-router-dom';
import { Repeat, Plus, ListOrdered, LogIn } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../hooks/useAuth';
import { PageLayout } from '../../components/layout/PageLayout';
import { AdSense } from '../../components/ads/AdSense';
import { useI18n } from '../../contexts/I18nContext';

export function TradeChoice() {
  const { user } = useAuth();
  const { t, getPathForLang } = useI18n();

  return (
    <PageLayout>
      <Helmet>
        <title>{t('trade_choice.seo.title')}</title>
        <meta name="description" content={t('trade_choice.seo.description')} />
      </Helmet>
      
      <div className="container mx-auto px-4 py-6 pb-8 md:pb-8">
        {/* Annonce AdSense unique */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 mb-6 max-w-lg mx-auto">
          <AdSense
            adSlot="1424794127"
            className="w-full"
            style={{ minHeight: '250px', display: 'block' }}
          />
        </div>
        
        {/* Section principale */}
        <div className="space-y-6 max-w-lg mx-auto">
          {/* Échanges */}
          <div>
            <h2 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3 px-2">
              {t('trade_choice.category_title')}
            </h2>
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
              <Link
                to={getPathForLang('/trades/browse')}
                className="flex items-center p-4 border-b border-gray-100 hover:bg-blue-50 transition-colors"
              >
                <div className="bg-blue-100 p-3 rounded-full">
                  <Repeat className="w-5 h-5 text-blue-600" />
                </div>
                <div className="ml-3">
                  <h2 className="font-semibold text-gray-900">{t('trade_choice.browse_trades.title')}</h2>
                  <p className="text-xs text-gray-600">{t('trade_choice.browse_trades.description')}</p>
                </div>
              </Link>

              {user ? (
                <>
                  <Link
                    to={getPathForLang('/trades/my-trades')}
                    className="flex items-center p-4 border-b border-gray-100 hover:bg-blue-50 transition-colors"
                  >
                    <div className="bg-indigo-100 p-3 rounded-full">
                      <ListOrdered className="w-5 h-5 text-indigo-600" />
                    </div>
                    <div className="ml-3">
                      <h2 className="font-semibold text-gray-900">{t('trade_choice.my_trades.title')}</h2>
                      <p className="text-xs text-gray-600">{t('trade_choice.my_trades.description')}</p>
                    </div>
                  </Link>

                  <Link
                    to={getPathForLang('/trades/create')}
                    className="flex items-center p-4 hover:bg-blue-50 transition-colors"
                  >
                    <div className="bg-green-100 p-3 rounded-full">
                      <Plus className="w-5 h-5 text-green-600" />
                    </div>
                    <div className="ml-3">
                      <h2 className="font-semibold text-gray-900">{t('trade_choice.create_trade.title')}</h2>
                      <p className="text-xs text-gray-600">{t('trade_choice.create_trade.description')}</p>
                    </div>
                  </Link>
                </>
              ) : (
                <Link
                  to={getPathForLang('/login')}
                  className="flex items-center p-4 hover:bg-blue-50 transition-colors"
                >
                  <div className="bg-purple-100 p-3 rounded-full">
                    <LogIn className="w-5 h-5 text-purple-600" />
                  </div>
                  <div className="ml-3">
                    <h2 className="font-semibold text-gray-900">{t('trade_choice.login.title')}</h2>
                    <p className="text-xs text-gray-600">{t('trade_choice.login.description')}</p>
                  </div>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
} 